import React, { createContext, useState } from 'react';

// Créer le contexte
export const BookingContext = createContext();

// Fournisseur de contexte pour les données de réservation
export const BookingProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [bookingData, setBookingData] = useState({
    // Données du praticien
    practitioner: null,
    // Données du service
    service: null,
    serviceTitle: null,
    duration: null,
    price: null,
    remotePrice: null, // Ajout du prix pour consultation à distance
    restTime: null,
    notes: null,
    canBeRemote: false, // Si le service peut être effectué à distance
    remoteOnly: false, // Si le service est uniquement à distance
    // Choix du type de consultation
    isRemote: false, // Si la consultation est à distance
    selectedDateRemoteOnly: false, // Si le jour sélectionné est uniquement à distance
    // Données temporelles
    date: null,
    time: null,
    formattedDate: null,
    // Informations du client
    name: null,
    email: null,
    phone: null,
    notes: null
  });

  // Mettre à jour les données de réservation
  const updateBookingData = (newData) => {
    setBookingData(prevData => ({
      ...prevData,
      ...newData
    }));
  };

  // Fonction pour définir le service sélectionné
  const setSelectedService = (service) => {
    if (!service) return;

    updateBookingData({
      service: service.id,
      serviceTitle: service.title,
      duration: service.duration,
      price: service.price,
      remotePrice: service.remotePrice, // Ajout du prix à distance
      restTime: service.restTime || 0,
      notes: service.notes,
      canBeRemote: service.canBeRemote || false,
      remoteOnly: service.remoteOnly || false,
      // Si le service est uniquement à distance, forcer isRemote à true
      isRemote: service.remoteOnly ? true : (bookingData.isRemote || false)
    });
  };

  // Fonction pour définir le praticien sélectionné
  const setSelectedPractitioner = (practitioner) => {
    if (!practitioner) return;

    updateBookingData({
      practitioner
    });
  };

  // Réinitialiser toutes les données de réservation
  const resetBookingData = () => {
    setBookingData({
      practitioner: null,
      service: null,
      serviceTitle: null,
      duration: null,
      price: null,
      remotePrice: null,
      restTime: null,
      notes: null,
      canBeRemote: false,
      remoteOnly: false,
      isRemote: false,
      selectedDateRemoteOnly: false,
      date: null,
      time: null,
      formattedDate: null,
      name: null,
      email: null,
      phone: null,
      notes: null
    });
    setCurrentStep(1);
  };

  return (
    <BookingContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        bookingData,
        updateBookingData,
        setSelectedService,
        setSelectedPractitioner,
        resetBookingData
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};